import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Nav = () => {
  const location = useLocation();

  const scrollToWaitlist = () => {
    if (location.pathname === '/') {
      document.getElementById('waitlist-form')?.scrollIntoView({ behavior: 'smooth' });
      if (window.gtag) {
        window.gtag('event', 'cta_click', {
          event_category: 'engagement',
          event_label: 'Join Waitlist Button - Navigation',
        });
      }
    } else {
      window.location.href = '/#waitlist-form';
    }
  };

  return (
    <nav className="nav-header" data-testid="nav-header">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <img
            src="/resfi-brand.svg"
            alt="resfi - Responsible Finance"
            style={{ height: '60px', width: 'auto' }}
          />
        </Link>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <Link
          to="/about-us"
          className="nav-link"
          data-testid="about-us-link"
          style={{
            color: location.pathname === '/about-us' ? 'var(--accent-primary)' : undefined,
            fontWeight: location.pathname === '/about-us' ? 600 : undefined,
          }}
        >
          About
        </Link>
        <button
          onClick={scrollToWaitlist}
          className="btn-primary nav-cta-button"
          data-testid="join-waitlist-nav-btn"
        >
          Join Waitlist
        </button>
      </div>
    </nav>
  );
};

export default Nav;
